import styled from "styled-components";

export const Icon = styled.img`
filter: invert(34%) sepia(39%) saturate(2088%) hue-rotate(312deg) brightness(93%) contrast(95%);
`
